export const GROUP_NAME_CHANGED = 'Group Name Changed'
export const CONTACT_SUPPORT = 'Contact Support'
export const RESET_PASSWORD = 'Reset Password'
